import React from 'react';

/**
 * Speech-bubble instruction delivered by the player's own avatar, e.g. a
 * short onboarding tip shown next to a step's title.
 */
export default function AvatarTip({ avatar, eyebrow = 'Cleptocracia', text }) {
  if (!avatar || !text) return null;
  return (
    <div className="avatar-tip">
      <div className="avatar-tip__avatar" dangerouslySetInnerHTML={{ __html: avatar }} />
      <div className="avatar-tip__bubble">
        <p className="avatar-tip__eyebrow">{eyebrow}</p>
        <p className="avatar-tip__text">{text}</p>
      </div>
    </div>
  );
}
